export default {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  PAUSED: 'PAUSED',
  ABORTED: 'ABORTED',
};
